import * as Sentry from "@sentry/browser";
import('./swiper');

Sentry.init({
    dsn: "https://3feb7cd48511676bd305a283f99c107f@o109994.ingest.sentry.io/4506116139581440",
});

import Parsley from "parsleyjs/dist/parsley";
import 'parsleyjs/dist/i18n/nl';
import ConsentManager from './consent/ConsentManager';
window.dataLayer = window.dataLayer || [];
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
import {Fancybox} from "@fancyapps/ui";
import "../../node_modules/@fancyapps/ui/dist/fancybox.css";

// Register the consent manager
ConsentManager.registerListener(consent => {
    console.log('New consent settings:', consent);
});

// Load the balance check if the page contains a balance-check element
if (document.getElementById('balance-check')) {
    import('./balanceCheck');
}

// Load the platform if the page contains a platform element
if (
    document.getElementById('platform') ||
    document.getElementById('search') ||
    document.getElementById('campaign')
) {
    console.log('[App] Platform element found, loading platform.js');
    import('./platform');
}

// Once window.giftyOfficeOpen = true, load the Trengo widget
console.log('window.giftyOfficeOpen:', window.giftyOfficeOpen);
if (window.giftyOfficeOpen) {
    if (
        !window.location.pathname.includes('/videoboodschap') &&
        !window.location.pathname.includes('/guestplan')
    ) {
        import('./trengo');
    }
}

$(window).on('load', () => {

    // Header button color update
    updateHeaderButton();
    $(window).on('scroll', function (e) {
        updateHeaderButton();
    });

    // Hero SVG animations
    $('.home-hero svg g').addClass('is-active');

    meetPopup();

    // Calendly popup
    $('.toggle-calendly').on('click', function (e) {
        e.preventDefault();

        ConsentManager.requireConsentToContinue(['functionality_storage', 'analytics_storage'])
            .then(() => {
                $('.calendly-popup iframe').attr('src', 'https://calendly.com/giftyhq/dash-demo?embed_domain=www.gifty.nl&embed_type=PopupText&hide_gdpr_banner=1');
                $('.calendly-popup').toggleClass('is-active');
            });
    });
    if (window.location.href.indexOf("#demo-inplannen") > -1 || $('#calendly-trigger').length > 0) {
        ConsentManager.requireConsentToContinue(['functionality_storage', 'analytics_storage'])
            .then(() => {
                $('.calendly-popup iframe').attr('src', 'https://calendly.com/giftyhq/dash-demo?embed_domain=www.gifty.nl&embed_type=PopupText&hide_gdpr_banner=1');
                $('.calendly-popup').addClass('is-active');
            });
    }
    if (window.location.href.indexOf("#meeting-met-sven") > -1) {
        ConsentManager.requireConsentToContinue(['functionality_storage', 'analytics_storage'])
            .then(() => {
                $('.calendly-popup iframe').attr('src', 'https://calendly.com/giftyhq/demo-met-sven?embed_domain=www.gifty.nl&embed_type=PopupText&hide_gdpr_banner=1');
                $('.calendly-popup').addClass('is-active');
            });
    }
    $('.calendly-popup-backdrop').on('click', function (e) {
        $('.calendly-popup').removeClass('is-active');
    });

    // Toggle samples popup
    if (window.location.href.indexOf("#samples") > -1) {
        $('.form-popup').fadeIn(300);
        setTimeout(function (e) {
            $('input[name="name"]').focus();
        }, 150);
    }

    // Popup timer
    popupTimer();

    // Fancybox
    Fancybox.bind("[data-fancybox]");

    // Auto focus on demo input
    setTimeout(() => {
        $('.autofocus').focus();
    }, 300);

    // Check if user is scrolled from top
    headerScroll();
    $(window).on('scroll', () => {
        headerScroll();
    });

    // Toggle language switch
    $('.footer__language-select').on('click', function (e) {
        $('.footer__language ul').fadeToggle(300);
    });

    // Toggle chapter dropdown
    $('.chapter-dropdown').on('click', function (e) {
        $('.chapter-dropdown-list').toggleClass('is-active');
    });

    $(document).on('click', 'a.scrollto', function (event) {
        event.preventDefault();
        const $el = $($(this).attr('href'));

        $('html, body').animate({
            scrollTop: $el.offset().top - $('header').outerHeight() + -25
        }, 500);
    });

    // Notification logic for switching locale
    if (document.getElementById('locale-switch')) {
        // If #locale-switch-deny is clicked, set the preferred locale in a cookie
        document.getElementById('locale-switch-deny').addEventListener('click', function (e) {
            e.preventDefault();

            // Set preferred locale in storage from HTML lang attribute
            setCookie('preferredLocale', document.documentElement.lang, 43200);

            // Remove the notification
            document.getElementById('locale-switch').remove();
        });
    }

    handleFormPopup();
});

// Request samples svg animations
$('.request-samples-svg').on('inview', function(event, isInView) {
    if (isInView) {
        $('.request-samples-svg [class^="cls-"]').addClass('is-active');
    }
});

/**
 * Inview elements
 */
$('.waterfall, .review__stars, .counter, .quote, .typer').on('inview', function (event, isInView) {
    let $this = $(this);
    if (isInView) {
        $this.addClass('in-view');

        // Counters
        if ($(this).hasClass('counter')) {
            $(this).find('.counter__number span').each(function () {
                let $this = $(this);
                $({counter: 0}).animate({counter: $this.data('count')}, {
                    duration: 2500,
                    easing: 'swing',
                    step: function () {
                        $this.text(Math.ceil(this.counter));
                    }
                });
            });
        }

        // Quotes
        if ($(this).hasClass('height-set')) {
            $(this).find('.quote__text em').typer();
        }

        // Typers
        if ($(this).hasClass('typer')) {
            $(this).typer();
        }
    } else {
        // element has gone out of viewport
        if ($(this).hasClass('counter')) {
            $this.removeClass('in-view');
        }
        if ($(this).hasClass('quote')) {
            $(this).find('.quote__text em').empty();
        }
    }
});

/**
 * Set quote text element heights
 */
$('.quote').each(function (e) {
    let elementHeight = $(this).find('.quote__text').outerHeight();
    $(this).find('.quote__text').css({
        height: elementHeight
    });
    $(this).find('.quote__text i').remove();
    $(this).addClass('height-set');
});

/**
 * Navicon toggle mobile
 */
$('.header__navicon').on('click', () => {
    $('body').toggleClass('navigation-active');
    $('.header__navicon .hamburger').toggleClass('hamburger--active');
    $('.header__navigation').toggleClass('header__navigation--visible');
    $('.header__navigation').removeClass('header__navigation--hide-left');
    $('.sub-navigation').removeClass('sub-navigation--visible');

    // If window is on top, add scrolled class
    if ($(window).scrollTop() === 0) {
        $('.header').toggleClass('header--scrolled');
    }
});

/**
 * Sub navigation toggle mobile
 */
if ($(window).width() < 1180) {
    $('.header__navigation a.has-sub').on('click', function (e) {
        e.preventDefault();

        let sub = $(this).data('sub');

        $('.header__navigation').addClass('header__navigation--hide-left');
        $('.sub-navigation[data-sub="' + sub + '"]').addClass('sub-navigation--visible');
    });

    // Back button
    $('.sub-navigation__back').on('click', function () {
        $('.sub-navigation').removeClass('sub-navigation--visible');
        $('.header__navigation').removeClass('header__navigation--hide-left');
    });
}

/**
 * Sub navigation toggle desktop
 */
if ($(window).width() >= 1180) {
    $('.header__navigation a.has-sub').on('click', function (e) {
        e.preventDefault();
    });
    $('.header__navigation a.has-sub').mouseenter(function () {
        let sub = $(this).data('sub');

        setTimeout(function () {
            $('.sub-navigation[data-sub!="' + sub + '"]').removeClass('sub-navigation--visible');
        }, 100);
        $('.sub-navigation[data-sub="' + sub + '"]').addClass('sub-navigation--visible');
    });

    // Remove sub navigations when hovering non parent items
    $('.header__navigation a').not('.has-sub').mouseenter(function () {
        $('.sub-navigation').removeClass('sub-navigation--visible');
    });
    $('.header').mouseleave(function () {
        $('.sub-navigation').removeClass('sub-navigation--visible');
    });


    // Hide sub navigation if the cursor is left or right of the main navigation within .header
    let offsetLeft = $('.header__navigation').offset().left;
    let offsetRight = $('.header__navigation').offset().left + $('.header__navigation').outerWidth();
    let scrolledTop = 0;
    $(window).on('scroll', function () {
        scrolledTop = document.documentElement.scrollTop;
    });
    $(document).mousemove(function (e) {
        let headerArea = e.pageY - scrolledTop;

        // Make sure it only checks the position if the cursor is within the fixed <header>
        if (headerArea <= 100) {
            // Check if cursor is within offset left or right from the .header__navigation
            // Remove the sub navigation if that is the case
            if (e.pageX < offsetLeft || e.pageX > offsetRight) {
                // Remove visible class from sub navigation
                $('.sub-navigation').removeClass('sub-navigation--visible');
            }
        }
    });
}

/**
 * Header scroll
 */
const headerScroll = () => {
    if ($(window).scrollTop() >= 50) {
        if (!$('.header').hasClass('header--scrolled')) {
            $('.header').addClass('header--scrolled');
        }
    } else {
        $('.header').removeClass('header--scrolled');
    }
}

// checks if the element is visible, only completely visible elements return true
function isInView(objEl) {
    let margin = 50;
    let rect = objEl.getBoundingClientRect();
    return rect.top >= margin && rect.bottom <= window.innerHeight - margin;
}

function isOutOfView(objEl) {
    let rect = objEl.getBoundingClientRect();
    return (
        rect.top <= -rect.height ||
        rect.bottom >= window.innerHeight + rect.height
    );
}

// starts playing animation if it is immediately visible
function playSvgIfInView(objEl) {
    if (isInView(objEl)) {
        objEl.contentDocument.defaultView.KeyshapeJS.globalPlay();
    }
}

window.addEventListener(
    "scroll",
    function () {
        let els = document.querySelectorAll(".scroll-activated");
        for (let i = 0; i < els.length; i++) {
            let el = els[i];
            if (isInView(el)) {
                playSvg(el);
            } else if (isOutOfView(el)) {
                resetSvg(el);
            }
        }
    },
    false
);

// plays svg animation in the given object element
function playSvg(objEl) {
    if (objEl.contentDocument && objEl.contentDocument.defaultView.KeyshapeJS) {
        let ks = objEl.contentDocument.defaultView.KeyshapeJS;
        if (ks.globalState() !== "running") {
            ks.globalPlay();
        }
    }
}

// pauses svg animation in the given object element
function resetSvg(objEl) {
    if (objEl.contentDocument && objEl.contentDocument.defaultView.KeyshapeJS) {
        let ks = objEl.contentDocument.defaultView.KeyshapeJS;
        if (ks.globalState() !== "idle" && ks.globalState() !== "paused") {
            var tls = ks.timelines();
            ks.remove(tls[0]); // removes the first timeline object
            ks.add(tls[0]); // adds the removed object back to the end of the list
            ks.globalPause();
        }
    }
}

/**
 * Popup timer
 * @returns {boolean}
 */
function popupTimer() {
    // Do nothing if cornerpopup_removed session exists
    if (sessionStorage.getItem("cornerpopup_removed") !== null) {
        return false;
    }

    // Check if cornerpopup already exists, if not, set a new cookie with +30 seconds expiration
    if (!getCookie('cornerpopup')) {
        setCookie("cornerpopup", '1', 0.2);
    }

    // If cornerpopup cookie is set, set 1 second interval to check if the cookie has expired
    if (getCookie('cornerpopup')) {
        let tim = setInterval(showPopup, 1000);
    }
}

/**
 * Show popup
 */
function showPopup() {
    if ($('.corner-popup').length > 0) {
        if (!getCookie('cornerpopup')) {
            $('.corner-popup').addClass('active');
        }
    }
}

/**
 * Corner popup link press
 */
$('.corner-popup-close, .corner-popup a').on('click', function (e) {
    if ($(this).attr('href') === '#') {
        e.preventDefault();
    }

    // setCookie("cornerpopup_disabled", '1', 1440);
    sessionStorage.setItem("cornerpopup_removed", "1");
    $('.corner-popup').hide();
});

/**
 * Set cookie
 * @param cname
 * @param cvalue
 * @param minutes
 */
function setCookie(cname, cvalue, minutes) {
    const d = new Date();
    d.setTime(d.getTime() + (minutes * 60 * 1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/**
 * Get cookie
 * @param cname
 * @returns {string}
 */
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function meetPopup() {
    let activeStep = 1;
    let checks = [];

    // Trigger meet popup
    $('.toggle-form-popup').on('click', function (e) {
        e.preventDefault();
        $('.form-popup').fadeIn(300);
        setTimeout(function (e) {
            $('input[name="name"]').focus();
        }, 150);
    });

    // On checkbox click event
    $('.form-popup-checkbox').on('click', function (e) {
        const checkId = $(this).data('id');

        // Add or remove clicked checkbox into checks array
        if (checks.includes(checkId)) {
            const index = checks.indexOf(checkId);
            if (index > -1) {
                checks.splice(index, 1);
            }
        } else {
            checks.push(checkId);
        }

        // Make sure the checkbox switches between active state
        $('.form-popup-checkbox[data-id="' + checkId + '"]').toggleClass('is-active');

        // If there is at least one checkbox active, make the next button clickable
        if (checks.length > 0) {
            $('.form-popup-footer-submit button').removeClass('button--disabled').attr('disabled', false);
        } else {
            $('.form-popup-footer-submit button').addClass('button--disabled').attr('disabled', true);
        }

        // Go to the next step if small screen and step 1
        if ($(window).width() < 992 && activeStep === 1) {
            goNext();
        }
    });

    // On button click event
    $('.form-popup-footer-submit button').on('click', function (e) {
        e.preventDefault();

        if (activeStep === 1) {
            goNext();
            $(this).text('Versturen');
        }

        // Submit form on step 2
        if (activeStep === 2) {
            const form = $('.form-popup form').parsley().validate();

            // if validation is valid
            if (form) {
                let $form = $('.form-popup form');
                let url = $form.attr('action');

                // Build the hidden input field with the selected checkboxes
                let choices = '';
                $('.form-popup-step-sidebar .form-popup-checkbox.is-active').each(function (e) {
                    choices += $(this).find('.form-popup-checkbox-title').text() + ', ';
                });
                $('.form-popup input[name="choices"]').val(choices);

                $('.form-popup-footer-submit button').addClass('button--loading');
                $.ajax({
                    type: "POST",
                    url: url,
                    data: $form.serialize(),
                    success: function (data) {
                        if (data === 'ok') {
                            setTimeout(function (e) {
                                // Send datalayer
                                window.dataLayer.push({
                                    'event': 'meet_form',
                                    'choices': choices,
                                    'firstname': $form.find('input[name="firstname"]').val(),
                                    'lastname': $form.find('input[name="lastname"]').val(),
                                    'company': $form.find('input[name="company"]').val(),
                                    'website': $form.find('input[name="website"]').val(),
                                    'email': $form.find('input[name="email"]').val(),
                                    'phone': $form.find('input[name="telephone"]').val(),
                                    'message': $form.find('textarea[name="message"]').val(),
                                });

                                $('.form-popup-footer-submit button').removeClass('button--loading').addClass('button--text').text('Sluiten');
                                $('.form-popup-footer-more').css({
                                    opacity: 0
                                });
                                // Go to the next step
                                goNext();
                            }, 500);
                        } else {
                            alert('Er is iets misgegaan. Probeer het opnieuw.')
                        }
                    }
                });
            }
        }

        // Close form on step 3
        if (activeStep === 3) {
            $('.form-popup').hide();
        }

    });

    // Next step logic
    function goNext() {
        let nextStep = activeStep + 1;
        // Step 1 and two needs to be below each other on small devices
        // we scroll to step 1 if that is the case
        if ($(window).width() < 992 && activeStep === 1) {
            if (activeStep === 1) {
                $('.form-popup-footer-submit button').text('Versturen');
                $('.form-popup-step[data-step="2"]').show();

                // Show send button
                $('.form-popup-footer-submit').show();
            }
        } else if ($(window).width() < 992 && activeStep === 2) {
            $('.form-popup-step[data-step="1"],.form-popup-step[data-step="2"]').hide();
            $('.form-popup-step[data-step="3"]').show();
            $('.form-popup-container').scrollTo('.form-popup-step[data-step="3"]');
        } else {
            // On large devices we hide all previous steps
            $('.form-popup-step[data-step="' + activeStep + '"]').removeClass('is-active').addClass('is-past');
            setTimeout(function (e) {
                $('.form-popup-step[data-step="' + activeStep + '"]').hide();
                $('.form-popup-step[data-step="' + nextStep + '"]').show().addClass('is-active').removeClass('is-future');
            }, 200);

            setTimeout(function (e) {
                // Scroll to the top of the popuo
                $('.form-popup-container').scrollTo('.form-popup-step.is-active');

                // Focus on first input value if switched to step 2 (desktop only)
                if (nextStep === 2 && $(window).width() > 992) {
                    $('input[name="firstname"]').focus();
                }
            }, 400);
        }

        setTimeout(function (e) {
            $('.form-popup').removeClass('active-step-' + activeStep);
            activeStep = activeStep + 1;
            $('.form-popup').addClass('active-step-' + activeStep);
        }, 500);
    }

    // Scroll to
    jQuery.fn.scrollTo = function (elem, speed) {
        $(this).animate({
            scrollTop: $(this).scrollTop() - $(this).offset().top + $(elem).offset().top - 100
        }, speed == undefined ? 500 : speed);
        return this;
    };
}

/**
 * Update header button color on scroll
 */
const updateHeaderButton = () => {
    if ($('.hero, .home-hero').length > 0) {
        const heroHeight = $('.hero, .home-hero').outerHeight();

        if ($(window).scrollTop() >= heroHeight) {
            $('header .button').addClass('button--primary');
        } else {
            $('header .button').removeClass('button--primary');
        }
    } else {
        $('header .button').addClass('button--primary');
    }
}

/**
 * Handle form popup behavior
 */
function handleFormPopup() {
    // Handle popup close
    $('.form-popup-backdrop,.form-popup-close,.close-window').on('click', function (e) {
        $('.form-popup').hide();
        // Set cookie for 3 days when popup is closed
        setCookie('form_popup_closed', '1', 4320); // 3 days in minutes
        $('.sample-widget').addClass('is-visible');
    });

    // Handle form submission
    $('#meet_form').on('submit', function (e) {
        e.preventDefault();
        $(this).find('button').addClass('button--loading');

        const $form = $(this);
        const url = $form.attr('action');

        $.ajax({
            type: "POST",
            url: url,
            data: $form.serialize(),
            success: function (data) {
                if (data === 'ok') {
                    // Set cookie for eternity when form is submitted
                    setCookie('form_popup_submitted', '1', 5256000); // ~10 years
                    setTimeout(function (e) {
                        $form.remove();
                        $('.form-popup-heading').remove();
                        $('.is-send').fadeIn();
                        $('.sample-widget').addClass('is-visible');
                    }, 500);
                } else {
                    alert('Er is iets misgegaan. Probeer het opnieuw.')
                    $(this).find('button').removeClass('button--loading');
                }
            }
        });
    });

    // Check if popup was previously closed or form was submitted
    // If not, show the sample widget after
    if (getCookie('form_popup_closed') || getCookie('form_popup_submitted')) {
        $('.sample-widget').addClass('is-visible');
        return;
    }
}
